import type { IconProps } from './../../models/icon';

export function HeadsetIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.14282 12V7.49138C5.15621 6.60515 5.34434 5.73028 5.69643 4.91687C6.04851 4.10348 6.55766 3.36755 7.19465 2.75125C7.83165 2.13496 8.58399 1.65041 9.40858 1.32538C10.2332 1.00034 11.1138 0.841213 12 0.857101C12.8861 0.841213 13.7668 1.00034 14.5913 1.32538C15.4159 1.65041 16.1683 2.13496 16.8053 2.75125C17.4423 3.36755 17.9515 4.10348 18.3036 4.91687C18.6555 5.73028 18.8437 6.60515 18.8571 7.49138V12"
        />
        <path
          fill={secondaryColor}
          d="M2.57146 9.42859H4.28575C4.51308 9.42859 4.7311 9.5189 4.89183 9.67965C5.05258 9.84038 5.14289 10.0584 5.14289 10.2857V15.4286C5.14289 15.6559 5.05258 15.8739 4.89183 16.0347C4.7311 16.1954 4.51308 16.2857 4.28575 16.2857H2.57146C2.1168 16.2857 1.68077 16.1051 1.35928 15.7836C1.03779 15.4621 0.857178 15.0261 0.857178 14.5714V11.1429C0.857178 10.6882 1.03779 10.2522 1.35928 9.93069C1.68077 9.60921 2.1168 9.42859 2.57146 9.42859Z"
        />
        <path
          fill={secondaryColor}
          d="M21.4286 16.2857H19.7143C19.487 16.2857 19.2689 16.1954 19.1081 16.0347C18.9475 15.8739 18.8572 15.6559 18.8572 15.4286V10.2857C18.8572 10.0584 18.9475 9.84038 19.1081 9.67965C19.2689 9.5189 19.487 9.42859 19.7143 9.42859H21.4286C21.8832 9.42859 22.3193 9.60921 22.6408 9.93069C22.9622 10.2522 23.1429 10.6882 23.1429 11.1429V14.5714C23.1429 15.0261 22.9622 15.4621 22.6408 15.7836C22.3193 16.1051 21.8832 16.2857 21.4286 16.2857Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.4285 21C16.3378 21 17.2098 20.6388 17.8528 19.9958C18.4958 19.3528 18.857 18.4807 18.857 17.5714V13.7143"
        />
        <path
          fill={secondaryColor}
          d="M15.4287 21C15.4287 21.5683 15.2029 22.1134 14.801 22.5152C14.3992 22.9171 13.8541 23.1428 13.2858 23.1428H10.7144C10.1461 23.1428 9.60103 22.9171 9.19917 22.5152C8.7973 22.1134 8.57153 21.5683 8.57153 21C8.57153 20.4317 8.7973 19.8865 9.19917 19.4847C9.60103 19.0829 10.1461 18.8571 10.7144 18.8571H13.2858C13.8541 18.8571 14.3992 19.0829 14.801 19.4847C15.2029 19.8865 15.4287 20.4317 15.4287 21Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.57146 9.42859H4.28575C4.51308 9.42859 4.7311 9.5189 4.89183 9.67965C5.05258 9.84038 5.14289 10.0584 5.14289 10.2857V15.4286C5.14289 15.6559 5.05258 15.8739 4.89183 16.0347C4.7311 16.1954 4.51308 16.2857 4.28575 16.2857H2.57146C2.1168 16.2857 1.68077 16.1051 1.35928 15.7836C1.03779 15.4621 0.857178 15.0261 0.857178 14.5714V11.1429C0.857178 10.6882 1.03779 10.2522 1.35928 9.93069C1.68077 9.60921 2.1168 9.42859 2.57146 9.42859Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4286 16.2857H19.7143C19.487 16.2857 19.2689 16.1954 19.1081 16.0347C18.9475 15.8739 18.8572 15.6559 18.8572 15.4286V10.2857C18.8572 10.0584 18.9475 9.84038 19.1081 9.67965C19.2689 9.5189 19.487 9.42859 19.7143 9.42859H21.4286C21.8832 9.42859 22.3193 9.60921 22.6408 9.93069C22.9622 10.2522 23.1429 10.6882 23.1429 11.1429V14.5714C23.1429 15.0261 22.9622 15.4621 22.6408 15.7836C22.3193 16.1051 21.8832 16.2857 21.4286 16.2857Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.4287 21C15.4287 21.5683 15.2029 22.1134 14.801 22.5152C14.3992 22.9171 13.8541 23.1428 13.2858 23.1428H10.7144C10.1461 23.1428 9.60103 22.9171 9.19917 22.5152C8.7973 22.1134 8.57153 21.5683 8.57153 21C8.57153 20.4317 8.7973 19.8865 9.19917 19.4847C9.60103 19.0829 10.1461 18.8571 10.7144 18.8571H13.2858C13.8541 18.8571 14.3992 19.0829 14.801 19.4847C15.2029 19.8865 15.4287 20.4317 15.4287 21Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
